






































































































































import Vue from 'vue';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import authService from '@/services/AuthService';
import miscService from '@/services/MiscService';
import nationexService from '@/services/NationexService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      displayConfirmPopup: false,
      showLoadingScreen: false,
      loadingScreenMessage: null,
      manifestDate: null,
      nationexManifestBase64: null,
      manifestShipments: [],
    };
  },
  created() {
    // check manifest permission
    if (!authService.hasNationexManifestAccess()) {
      miscService.goToPage('/');
    }
  },
  methods: {
    startLoading(message) {
      this.showLoadingScreen = true;
      this.loadingScreenMessage = message;
    },
    stopLoading() {
      this.showLoadingScreen = false;
      this.loadingScreenMessage = null;
    },
    backToShipments() {
      window.location.href = '/customer/shipments';
    },
    cancelConfirm() {
      this.displayConfirmPopup = false;
      this.manifestShipments = [];
    },
    confirmGenerate() {
      if (!this.manifestShipments.length) {
        this.$toast.error(
          'No Nationex Parcel shipments found for selected date...'
        );
        return;
      }

      this.startLoading('Generating Nationex Parcel manifest...');
      this.displayConfirmPopup = false;
      nationexService
        .generateNationexParcelManifest(this.user?.accountId, this.manifestDate)
        .then((x: any) => {
          if (!x?.length) {
            this.showNationexManifestError();
          }

          this.$toast.show(
            'Nationex Parcel manifest generated successfully, Shipment IDs#: ' +
              this.tmsShipmentIdsArray.join(', ')
          );

          this.loadAndShopPdf();
        })
        .catch(() => {
          this.showNationexManifestError();
        })
        .finally(() => {
          this.stopLoading();
          this.manifestShipments = [];
        });
    },
    showNationexManifestError() {
      this.$toast.error(
        'Failed to generate Nationex Parcel manifest, please contact tmssupport@afs.net...'
      );
    },
    loadAndShopPdf() {
      setTimeout(() => {
        this.startLoading(
          'Loading Nationex Parcel manifest PDF for Shipment IDs#: ' +
            this.tmsShipmentIdsArray.join(', ') +
            '...'
        );

        nationexService
          .generateNationexParcelManifest(
            this.user.accountId,
            this.manifestDate
          )
          .then((x: any) => {
            console.log('File', x);

            if (x?.manifestPdf?.length > 100) {
              this.nationexManifestBase64 = x.manifestPdf;
            }
          })
          .catch(() => {
            this.failedToShowPdfFile(this.tmsShipmentIdsArray.join(', '));
          })
          .finally(() => {
            this.stopLoading();
          });
      }, 1000);
    },
    failedToShowPdfFile() {
      this.$toast.error(
        'Failed to show Nationex Parcel manifest PDF for Shipment IDs#: ' +
          this.tmsShipmentIdsArray.join(', ') +
          ', please contact tmssupport@afs.net...'
      );
    },
    manifestDateChanged(date) {
      if (!this.user?.accountId) {
        this.backToShipments();
        return;
      }

      if (!date) {
        this.$toast.error(
          'Please select a date to generate Nationex manifest.'
        );
        return;
      }

      this.startLoading('Validating Nationex shipments for selected date...');
      this.manifestShipments = [];
      nationexService
        .getNationexManifestEligibleParcelShipmentIds(this.user.accountId, date)
        .then((x: any) => {
          if (!x?.length) {
            this.$toast.show(
              'No Nationex Parcel shipments found for selected date...'
            );
            return;
          }

          this.displayConfirmPopup = true;
          this.manifestShipments = x;
        })
        .catch(() => {
          this.$toast.error(
            'Failed to validate Nationex shipments for selected date...'
          );
        })
        .finally(() => {
          this.stopLoading();
        });
    },
  },
  computed: {
    tmsShipmentIds() {
      return this.manifestShipments.map((x) => x).join(', ');
    },
    tmsShipmentIdsArray() {
      return this.manifestShipments.map((x) => x);
    },
    nationexManifestBase64Computed() {
      return this.nationexManifestBase64;
    },
  },
  watch: {},
});
